module.exports = __webpack_public_path__ + "img/vestiaires-5.7cc57f6c.jpg";